import { Component } from '@angular/core';
import { Ignorering as Ignorering } from '../../models/ignore';
import { NameType } from '../../../shared/models/models';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardNamnService } from '../../standard-namn/standard-namn.service';
import { StandardNamnFormModel } from '../../../shared/models/standard-namn';
import { SessionService } from 'src/app/auth/services/session.service';

@Component({
    selector: 'lib-ignorerade-edit-dialog',
    templateUrl: './ignorerade-edit-dialog.component.html',
    styleUrls: ['./ignorerade-edit-dialog.component.css'],
    standalone: false
})
export class IgnoreradeEditDialogComponent {
  ignorering!: Ignorering;
  nameType!: NameType;
  standardNamnList: StandardNamnFormModel[] = [];

  form!: FormGroup;

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private standardNamnService: StandardNamnService
  ) {}

  ngOnInit(): void {
    this.ignorering = this.config.data?.ignorering;
    this.nameType = this.config.data?.nameType;

    this.form = new FormGroup({
      comment: new FormControl<string | null>(this.ignorering.comments),
      selectedStandardNamn: new FormControl<StandardNamnFormModel | null>(null, Validators.required),
    });

    this.getStandardnamn(this.nameType);
  }

  async getStandardnamn(type: NameType) {
    const result = await this.standardNamnService.getStandardNamn(type);
    this.standardNamnList = result.map((s) => ({
      name: s.standardNamn,
      id: s.id,
    }));
  }

  save() {
    const modifiedIgnorering = {
      ...this.ignorering,
      name: this.form.value.selectedStandardNamn,
      comments: this.form.value.comment,
      modifiedBy: this.form.value.modifiedBy
     }
    this.ref.close(modifiedIgnorering);
  }

  close() {
    this.ref.close();
  }
}
